export interface DateObject {
  year: number;
  month: number;
  day: number;
}

export const textToObject = (text: string): DateObject => {
  const textSplited = text.split("/");

  return {
    year: Number(textSplited[0]),
    month: Number(textSplited[1]),
    day: Number(textSplited[2]),
  };
};

export const objectToText = (date: DateObject): string => {
  return `${date.year}-${date.month}-${date.day}`;
};

export const persianToGregorian = (persianDateString: string): string => {
  const [jy, jm, jd] = persianDateString.split("-").map(Number);

  // Validate the input Persian date
  if (
    isNaN(jy) ||
    isNaN(jm) ||
    isNaN(jd) ||
    jm < 1 ||
    jm > 12 ||
    jd < 1 ||
    jd > (jm <= 6 ? 31 : jm <= 11 ? 30 : 29)
  ) {
    throw new Error("Invalid Persian date string");
  }

  function jalaliToJDN(jy: number, jm: number, jd: number): number {
    const epbase = jy - (jy >= 0 ? 474 : 473);
    const epyear = 474 + (epbase % 2820);
    return (
      jd +
      (jm <= 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186) +
      Math.floor((epyear * 682 - 110) / 2816) +
      (epyear - 1) * 365 +
      Math.floor(epbase / 2820) * 1029983 +
      1948320.5
    );
  }

  function jdnToGregorian(jdn: number): string {
    let z = Math.floor(jdn + 0.5); // Ignore fractional day
    let A = z;

    if (z >= 2299161) {
      const alpha = Math.floor((z - 1867216.25) / 36524.25);
      A += 1 + alpha - Math.floor(alpha / 4);
    }

    const B = A + 1524;
    const C = Math.floor((B - 122.1) / 365.25);
    const D = Math.floor(365.25 * C);
    const E = Math.floor((B - D) / 30.6001);

    const day = Math.floor(B - D - Math.floor(30.6001 * E)); // Exclude fractional day part
    const month = E < 14 ? E - 1 : E - 13;
    const year = month > 2 ? C - 4716 : C - 4715;

    return `${year}-${String(month).padStart(2, "0")}-${String(
      day - 1
    ).padStart(2, "0")}`;
  }

  const jdn = jalaliToJDN(jy, jm, jd);
  return jdnToGregorian(jdn);
};


export function jalali_to_gregorian(jy: number, jm: number, jd: number) {
  let gy, gm, gd, days, sal_a, v;

  if (jy > 979) {
    gy = 1600;
    jy -= 979;
  } else {
    gy = 621;
  }
  days =
    365 * jy +
    parseInt("" + jy / 33) * 8 +
    parseInt("" + ((jy % 33) + 3) / 4) +
    78 +
    jd +
    (jm < 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186);
  gy += 400 * parseInt("" + days / 146097);
  days %= 146097;
  if (days > 36524) {
    gy += 100 * parseInt("" + --days / 36524);
    days %= 36524;
    if (days >= 365) days++;
  }
  gy += 4 * parseInt("" + days / 1461);
  days %= 1461;
  if (days > 365) {
    gy += parseInt("" + (days - 1) / 365);
    days = (days - 1) % 365;
  }
  gd = days + 1;
  sal_a = [
    0,
    31,
    (gy % 4 == 0 && gy % 100 != 0) || gy % 400 == 0 ? 29 : 28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31,
  ];
  for (gm = 0; gm < 13; gm++) {
    v = sal_a[gm];
    if (gd <= v) break;
    gd -= v;
  }
  return `${gy}-${gm}-${gd}`;
}
